module.exports = __webpack_public_path__ + "img/sample-error-5.c113258.webp";